const GROUPS = {
  VDP : ["VDP","VDP_RLSA"],
  MM  : ["SRP_MM","SRP_MM_RLSA"],
  MMY : ["SRP_MMY","SRP_MMY_RLSA"],
  CONQUEST : ["CONQUEST"]
}

export default GROUPS
